'use client';

import React from 'react';

interface EmptyStateAction {
  label: string;
  href?: string;
  onClick?: () => void;
}

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: EmptyStateAction;
  icon?: React.ReactNode;
  className?: string;
  variant?: 'page' | 'section';
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  action,
  icon,
  className = '',
  variant = 'section',
}) => {
  const isPage = variant === 'page';
  const ActionTag = action?.href ? 'a' : 'button';

  return (
    <div
      className={`mx-auto flex flex-col items-center text-center ${
        isPage
          ? 'min-h-[60vh] justify-center px-6 py-16'
          : 'my-20 max-w-2xl rounded-xl border border-gray-200 p-8'
      } ${className}`}
    >
      {icon && (
        <div className="bg-primary/10 mb-6 flex h-16 w-16 items-center justify-center rounded-full">
          {icon}
        </div>
      )}

      <h2
        className={`font-muli text-text-primary font-bold ${
          isPage ? 'text-3xl' : 'text-lg'
        }`}
      >
        {title}
      </h2>

      {description && (
        <p
          className={`font-muli text-text-secondary mt-3 ${
            isPage ? 'text-base' : 'text-sm'
          }`}
        >
          {description}
        </p>
      )}

      {action && (
        <ActionTag
          type={ActionTag === 'button' ? 'button' : undefined}
          href={action.href}
          onClick={action.onClick}
          className="bg-primary hover:bg-primary-hover focus-visible:ring-primary mt-6 inline-flex items-center rounded-lg px-6 py-3 text-sm font-semibold text-white transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
        >
          {action.label}
        </ActionTag>
      )}
    </div>
  );
};

export default EmptyState;
